import { render, staticRenderFns } from "./PointsView.vue?vue&type=template&id=f8afa6ae&scoped=true&"
import script from "./PointsView.vue?vue&type=script&lang=js&"
export * from "./PointsView.vue?vue&type=script&lang=js&"
import style0 from "./PointsView.vue?vue&type=style&index=0&id=f8afa6ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8afa6ae",
  null
  
)

export default component.exports